import {
    AgentDetailSlice,
    IAgentHierarchyInformation,
    IAgentLicensedState,
    IAgentProductDetails,
    IAgentRestrictedFields,
} from "../../agentDetail.model";

export const initialAgentDetailState: AgentDetailSlice = {
    activeUserId: null,
    data: null,
    draft: null,
    status: "idle",
    error: null,
    saveStatus: "idle",
    saveError: null,
    isEditMode: false,
};

export const EMPTY_RESTRICTED_FIELDS: IAgentRestrictedFields = {
    personalInformation: [],
    businessInformation: [],
    contractAndLicensingInformation: [],
    actionButtons: []
};

export const EMPTY_LICENSED_STATES: IAgentLicensedState[] = [];
export const EMPTY_PRODUCTS: IAgentProductDetails[] = [];
export const EMPTY_HIERARCHY: IAgentHierarchyInformation[] = [];
